export default {
  API_URL: "https://testapi.xs2event.com/v1",
  STRAPI_API_URL: import.meta.env.VITE_STRAPI_API_URL || "https://cms.xs2event.com/api",
  strapiType: "Webpage",
  CDN_URL: "https://cdn.xs2event.com",
  ENV: "test",
  VERSION: "3bfd5d81",
  FLAGS_BASE_URL: "https://cdn.xs2event.com/flags-test",
  SENTRY_ENABLE: false,
  WEBAPP: "webpage3",
};
